import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Card, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';

import UploadFiles from 'components/common/UploadFiles';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SoftBadge from 'components/common/SoftBadge';
import IconButton from 'components/common/IconButton';

const Documents = ({ data, isLoading, onSubmitData, onError }) => {
 const [up, setUp] = useState(false);
 const {
  watch,
  reset,
  register,
  setValue,
  handleSubmit,
  formState: { errors }
 } = useForm({
  defaultValues: {
   documents: [
    { name: 'rut', doc: null, verify: null },
    { name: 'comercio', doc: null, verify: null },
    { name: 'recibo', doc: null, verify: null }
   ].map(e => ({ ...e, ...data?.documents?.find(a => a?.name === e.name) }))
  }
 });

 useEffect(() => {
  if (up) {
   reset({ documents: watch('documents')?.map(e => ({ ...e, ...data?.documents?.find(a => a?.name === e.name) })) });
   setUp(false);
  }
 }, [data?.documents]);

 return (
  <Card className="">
   <Card.Body className="bg-100 fs--1">
    <h5 className="mb-0 text-primary position-relative">
     <span className="bg-100 dark__bg-1100 pe-3">Verificación</span>
     <span className="border position-absolute top-50 translate-middle-y w-100 start-0 z-index--1"></span>
    </h5>

    <p className="mb-1">
     Seleccione las imagenes o pdf de los documentos para la validacion correspondiente de la Empresa legalmente como tal.Estos
     documentos serian:
    </p>

    <ul className="fa-ul ms-2 ps-x1 mb-0">
     <li className="py-0">
      <h6 className="text-700">
       <FontAwesomeIcon icon="plus" className="fa-li text-success" />
       Rut (Registro Único Tributario)
      </h6>
     </li>

     <li className="py-0">
      <h6 className="text-700">
       <FontAwesomeIcon icon="plus" className="fa-li text-success" />
       Cámara de Comercio
      </h6>
     </li>

     <li className="py-0">
      <h6 className="text-700">
       <FontAwesomeIcon icon="plus" className="fa-li text-success" />
       Factura de un Servicio Publico a nombre de la Empresa
      </h6>
     </li>
    </ul>

    <div className="position-relative">
     <UploadFiles
      preview={true}
      className="mb-2"
      multiple={false}
      accept="application/pdf"
      dropzoneArea={!watch('documents.0.doc')}
      files={watch('documents.0')?.doc}
      style={{ maxHeight: 100 }}
      register={register('documents.0.doc')}
      onChange={e => setValue('documents.0', { name: 'rut', doc: !e?.length ? null : e, verify: null })}
      placeholder={
       watch('documents.0.doc') ? (
        ''
       ) : (
        <div>
         <img src={cloudUpload} alt="" width={25} className="me-2" />
         Subir Documento RUT
        </div>
       )
      }
     />
     {/[0-9]/.test(watch('documents')[0]?.verify) ? (
      <>
       <SoftBadge
        pill
        bg={watch('documents.0.verify') > 0 ? 'success' : 'primary'}
        className="me-3 position-absolute fs--2 top-0 end-0 translate-middle-y z-index-1"
       >
        <FontAwesomeIcon icon={watch('documents.0.verify') > 0 ? 'check-circle' : 'clock'} className="me-1" />
        {watch('documents.0.verify') > 0 ? 'Verificado' : 'Pendiente'}
       </SoftBadge>
       <h4 className="position-absolute fs--2 top-50 start-50 translate-middle z-index-2">RUT</h4>
      </>
     ) : watch('documents.0.doc') ? (
      <h4 className="position-absolute fs--2 top-50 start-50 translate-middle z-index-2">RUT</h4>
     ) : (
      <></>
     )}
    </div>

    <div className="position-relative">
     <UploadFiles
      preview={true}
      className="mb-2"
      multiple={false}
      accept="application/pdf"
      dropzoneArea={!watch('documents.1.doc')}
      files={watch('documents.1')?.doc}
      style={{ maxHeight: 100 }}
      register={register('documents.1.doc')}
      onChange={e => setValue('documents.1', { name: 'comercio', doc: !e?.length ? null : e, verify: null })}
      placeholder={
       watch('documents.1.doc') ? (
        <></>
       ) : (
        <div>
         <img src={cloudUpload} alt="" width={25} className="me-2" />
         Subir Documento CCM
        </div>
       )
      }
     />
     {/[0-9]/.test(watch('documents')[1]?.verify) ? (
      <>
       <SoftBadge
        pill
        bg={watch('documents.1.verify') > 0 ? 'success' : 'primary'}
        className="me-3 position-absolute fs--2 top-0 end-0 translate-middle-y z-index-1"
       >
        <FontAwesomeIcon icon={watch('documents.1.verify') > 0 ? 'check-circle' : 'clock'} className="me-1" />
        {watch('documents.1.verify') > 0 ? 'Verificado' : 'Pendiente'}
       </SoftBadge>
       <h4 className="position-absolute fs--2 top-50 start-50 translate-middle z-index-2">CCM</h4>
      </>
     ) : watch('documents.1.doc') ? (
      <h4 className="position-absolute fs--2 top-50 start-50 translate-middle z-index-2">CCM</h4>
     ) : (
      <></>
     )}
    </div>

    <div className="position-relative">
     <UploadFiles
      preview={true}
      className="mb-2"
      multiple={false}
      accept="image/*"
      dropzoneArea={!watch('documents.2.doc')}
      files={watch('documents.2')?.doc}
      style={{ maxHeight: 300 }}
      register={register('documents.2.doc')}
      onChange={e => setValue('documents.2', { name: 'recibo', doc: !e?.length ? null : e, verify: null })}
      placeholder={
       watch('documents.2.doc') ? (
        ''
       ) : (
        <div>
         <img src={cloudUpload} alt="" width={25} className="me-2" />
         Subir Imagen RCB
        </div>
       )
      }
     />
     {/[0-9]/.test(watch('documents')[2]?.verify) ? (
      <>
       <SoftBadge
        pill
        bg={watch('documents.2.verify') > 0 ? 'success' : 'primary'}
        className="me-3 position-absolute fs--2 top-0 end-0 translate-middle-y z-index-1"
       >
        <FontAwesomeIcon icon={watch('documents.2.verify') > 0 ? 'check-circle' : 'clock'} className="me-1" />
        {watch('documents.2.verify') > 0 ? 'Verificado' : 'Pendiente'}
       </SoftBadge>
       <h4 className="position-absolute fs--2 top-50 start-50 translate-middle z-index-2">RCB</h4>
      </>
     ) : watch('documents.2.doc') ? (
      <h4 className="position-absolute fs--2 top-50 start-50 translate-middle z-index-2">RCB</h4>
     ) : (
      <></>
     )}
    </div>

    {errors.documents && <Alert variant="danger" message={errors.documents.message} />}
    <p className="text-700">
     {' '}
     Tenga en cuenta: que La informacion de este Formulario diligenciado debe coincidir con la informacion suministrada en estos
     documentos.
    </p>

    {isLoading && up && <Spinner animation="border" variant="primary" className="float-start" />}
    <IconButton
     icon="plus"
     className="m-2 fs--1 float-end"
     //classText="d-none d-sm-block"
     transform="shrink-2"
     size="sm"
     variant="falcon-default"
     onClick={() => {
      setUp(true);
      handleSubmit(onSubmitData, onError)();
     }}
    >
     Enviar
    </IconButton>
   </Card.Body>
  </Card>
 );
};

Documents.propTypes = {
 data: PropTypes.object,
 isLoading: PropTypes.bool,
 onSubmitData: PropTypes.func.isRequired,
 onError: PropTypes.func.isRequired
};

export default Documents;
